export default __webpack_public_path__ + "ecf32e3fadcd3beb0d6130b4ed62f4b6.svg";